cv.NotificationBehavior = Marionette.Behavior.extend({
    // you can set default options
    // just like you can in your Backbone Models
    // they will be overriden if you pass in an option with the same key
    defaults: {
    },

    // behaviors have events that are bound to the views DOM
    events: {
    },

    collectionEvents: {
    },

    initialize: function(){
      // Notification channel
      this.listenTo(vent, 'notif:success', this.notifSuccess, this);
      this.listenTo(vent, 'notif:error', this.notifError, this);
      this.listenTo(vent, 'notif:clear', this.notifClear, this);

      console.log('NotificationBehavior initialized.');
    },

    notifClear: function(type){
      if(_.isUndefined(type)){
        this.view.$('.notif').remove();
      }else{
        this.view.$('.notif.' + type).remove();
      }
    },

    notifSuccess: function(msg){
      this.notif('success', msg);
    },

    notifError: function(msg){
      this.notif('error', msg);
    },

    notif: function(type, msg){
      if(this.view.$('.notif.error').length > 0 && type != 'success'){
        return;
      }
      if(this.view.$('.notif.success').length > 0 && type != 'error'){
        return;
      }
      this.view.$('.notif').remove();

      this.view.$el.append('<div class="notif ' + type + '"><a class="close" data-bypass="true">&times;</a>' +
        '<div class="message">' + msg + '</div></div>');

      setTimeout(_.bind(function(){
        this.view.$('.notif').addClass('active');
      }, this), 10);


      this.view.$('.notif .close').on('click', _.bind(function(){
        this.view.$('.notif').removeClass('active');
        setTimeout(_.bind(function(){
          this.view.$('.notif').remove();
        }, this), 250);
      }, this));

      if(type != 'error'){
        setTimeout(_.bind(function(){
          this.view.$('.notif').removeClass('active');
          setTimeout(_.bind(function(){
            this.view.$('.notif').remove();
          }, this), 250);
        }, this), 4000);
      }
    }
});